/**
 * Vega FaceRenderer + redrawn mouth shapes (morph + 3 openness levels).
 * Eyes are zeroed so CharacterEmbed2 keeps Quan's own eye states.
 */
import packedFace from "./vega/face-packed.json";
import FaceRenderer from "./vega/renderer.js";

type PackedLevels = Record<string, Record<string, string>>;
type PackedFace = {
  eyes: Record<string, string>;
  mouths: Record<string, string>;
  mouthLevels?: PackedLevels;
};

const PIXEL_COUNT = 48 * 48;

function unpackBits(b: string): Uint8Array {
  const s = atob(b);
  const a = new Uint8Array(PIXEL_COUNT);
  for (let i = 0; i < PIXEL_COUNT; i++) a[i] = (s.charCodeAt(i >> 3) >> (i & 7)) & 1;
  return a;
}

function unpackFace(packed: PackedFace) {
  const empty = new Uint8Array(PIXEL_COUNT);
  const mouths: Record<string, Uint8Array> = {};
  for (const key of Object.keys(packed.mouths)) mouths[key] = unpackBits(packed.mouths[key]);
  const mouthLevels: Record<string, Record<string, Uint8Array>> = {};
  if (packed.mouthLevels) {
    for (const viseme of Object.keys(packed.mouthLevels)) {
      mouthLevels[viseme] = {};
      for (const level of Object.keys(packed.mouthLevels[viseme])) {
        mouthLevels[viseme][level] = unpackBits(packed.mouthLevels[viseme][level]);
      }
    }
  }
  return {
    eyes: { NEUTRAL: empty, BLINK: empty },
    mouths,
    mouthLevels,
  };
}

let renderer: FaceRenderer | null = null;

export function getVegaFaceRenderer(): FaceRenderer {
  if (!renderer) {
    renderer = new FaceRenderer(unpackFace(packedFace as PackedFace), {
      blendMs: 80,
      levels: true,
      blink: false,
    });
  }
  return renderer;
}
